import {
  WidgetType,
  MatchDecorator,
  Decoration,
  ViewPlugin,
  EditorView,
} from "@codemirror/view";

class ProductTokenWidget extends WidgetType {
  value;
  label;

  constructor(value, label) {
    super();
    this.value = value;
    this.label = label;
  }

  toDOM() {
    const span = document.createElement("span");

    span.textContent = this.label || this.value;
    span.className = "token-product";
    return span;
  }
}

const createProductTokenExtension = (productProperties) => {
  const productTokenMatcher = new MatchDecorator({
    regexp: /{{(product\.([a-z0-9_]+))}}/g,
    decoration: (match) => {
      const property = productProperties.find((prop) => prop.name === match[2]);
      if (!property) return null;

      return Decoration.replace({
        widget: new ProductTokenWidget(match[2], property.label),
      });
    },
  });

  return ViewPlugin.fromClass(
    class {
      tokens;
      constructor(view) {
        this.tokens = productTokenMatcher.createDeco(view);
      }
      update(update) {
        this.tokens = productTokenMatcher.updateDeco(update, this.tokens);
      }
    },
    {
      decorations: (instance) => instance.tokens,
      provide: (plugin) =>
        EditorView.atomicRanges.of((view) => {
          return view.plugin(plugin)?.tokens || Decoration.none;
        }),
    },
  );
};

export default createProductTokenExtension;
